export default {
  menu: {
    Home: {
      Title: "首頁",
    },
    Search: "查詢",
    Versions: "版本更新說明",
    Api: {
      Title: "開發原則",
      Api: "如何使用 HiTRUSTpay RESTful API ",
    },
    Auth: {
      Title: "授權交易服務",
      Auth: "信用卡交易授權",
      TrxtokenAuth: "交易序號交易授權",
      BindingCardAuth: "信用卡綁卡交易授權",
      AuthSSL: "信用卡交易直接授權",
      TrxtokenAuthSSL: "交易序號交易直接授權",
      MobileAuth: "行動支付加密資料交易授權",
      MobileAuthDecrypted: "行動支付已解密資料交易授權",
      AfteeAuth: "AFTEE交易授權",
      LinepayAuth: "LINE Pay交易授權",
      IpassAuth: "一卡通交易授權",
      CfcAuth: "銀角零卡分期交易授權授權",
      EzwAuth: "悠遊付交易授權",
      JkoAuth: "街口交易授權",
      PxPayAuth: "全支付交易授權",
      UpopAuth: "銀聯卡交易授權",
      FollowPay: "Follow Pay交易授權",
      Jpay: "J-PAY交易授權",
    },
    Query: {
      Title: "查詢交易服務",
      QueryOrder: "信用卡交易查詢",
      QueryFunbizOrder: "豐收款交易查詢",
      QueryUpopOrder: "銀聯交易查詢",
      AfteeQuery: "AFTEE交易查詢",
      CfcQueryOrder: "銀角零卡分期交易查詢",
      EzwQueryOrder: "悠遊付交易查詢",
      IpassQueryOrder: "一卡通交易查詢",
      JkoQueryOrder: "街口支付交易查詢",
      LinepayQueryOrder: "LINE Pay交易查詢",
      PxPayQueryOrder: "全支付交易查詢",
      JpayQueryOrder: "J-PAY交易查詢",
    },
    Transaction: {
      Title: "交易管理服務",
      AuthReverse: "取消交易授權",
      Capture: "交易請款",
      CaptureReverse: "取消交易請款",
      Refund: "交易退款",
      RefundReverse: "取消交易退款",
      UpopAuthReverse: "取消銀聯交易授權",
      UpopCapture: "銀聯交易請款",
      UpopCaptureReverse: "取消銀聯交易請款",
      UpopRefund: "銀聯交易退款",
      UpopRefundReverse: "取消銀聯交易退款",
      CardholderVerify: "手機門號驗證",
    },
    AP: {
      Title: "虛擬帳號付款服務",
      VirtualAccountPayment: "虛擬帳號付款交易",
      VirtualAccountQuery: "虛擬帳號訂單查詢",
      SpbVirtualAccountRefund: "永豐虛擬帳號退款",
    },
    Cvs: {
      Title: "超商代收服務",
      CvsPayment: "超商代收",
      CvsQuery: "超商代收訂單查詢",
    },
    Easypay: {
      Title: "方便付服務",
      EasypayCreate: "方便付建立付款連結",
      EasypayQuery: "方便付訂單查詢",
      EasypayUpdate: "方便付訂單狀態變更",
    },
    RecurringPayment: {
      Title: "定期定額交易服務",
      CancelRecurringPayment: "取消定期定額訂單",
      ResendRecurringPayment: "重送交易失敗定期定額訂單",
      QueryRecurringPayment: "定期定額訂單查詢",
    },
    VeriId: {
      Title: "Veri-id服務",
      VeriIdReviewOrder: "Veri-id 審核風險交易",
      VeriIdQueryRiskTransactionData: "查詢交易 Veri-id 風險偵測結果",
    },
    References: {
      Title: "交易參考資料",
      Retcode: "回傳訊息對照表（retcode）",
      TestCardData: "測試卡號資訊",
      OrderStatus: "訂單狀態碼",
    },
    Param: {
      Title: "參數",
      AuthRequest: "信用卡交易授權 Request 物件",
      AuthResponse: "信用卡交易授權 Response 物件",
      ReturnUrlQuery: "回傳指定接續網址 ReturnURL Query 參數",
      UpdateAuthRequest: "信用卡交易授權結果通知 Request JSON物件",
      ApiReponseError:
        "無法通過HiTRUSTpay驗證，則回應Error Response Model 如下",
      ApiReponseModel:
        "回應 HiTRUSTpay API 規格Response，API Response Model 格式如下",
      TrxtokenAuthRequest: "交易序號交易授權 Request 物件",
      TrxtokenAuthResponse: "交易序號交易授權 Response 物件",
      UpdateTrxtokenAuthRequest: "交易序號交易授權結果通知 Request JSON 物件",
      BindingCardAuthRequest: "信用卡綁卡交易授權 Request 物件",
      BindingCardAuthResponse: "信用卡綁卡交易授權 Response 物件",
      UpdateBindingCardAuthRequest:
        "信用卡綁卡交易授權結果通知 Request JSON 物件",
      AuthSSLRequest: "信用卡交易直接授權 Request 物件",
      AuthSSLResponse: "信用卡交易直接授權 Response 物件",
      UpdateAuthSSLRequest: "信用卡交易直接授權結果通知 Request JSON 物件",
      TrxtokenAuthSSLRequest: "交易序號交易直接授權 Request 物件",
      TrxtokenAuthSSLResponse: "交易序號交易直接授權 Response 物件",
      UpdateTrxtokenAuthSSLRequest:
        "交易序號交易直接授權結果通知 Request JSON 物件",
      MobileAuthRequest: "行動支付加密資料交易授權 Request 物件",
      MobileAuthResponse: "行動支付加密資料交易授權 Response 物件",
      UpdateMobileAuthRequest:
        "行動支付加密資料交易授權結果通知 Request JSON 物件",
      MobileAuthDecryptedRequest: "行動支付已解密資料交易授權 Request 物件",
      MobileAuthDecryptedResponse: "行動支付已解密資料交易授權 Response 物件",
      UpdateMobileAuthDecryptedRequest:
        "行動支付已解密資料交易授權結果通知 Request JSON 物件",
      AfteeAuthRequest: "AFTEE交易授權 Request 物件",
      AfteeAuthResponse: "AFTEE交易授權 Response 物件",
      UpdateAfteeAuthRequest: "AFTEE交易授權結果通知 Request JSON 物件",
      LinepayAuthRequest: "LINE Pay交易授權 Request 物件",
      LinepayAuthResponse: "LINE Pay交易授權 Response 物件",
      UpdateLinepayAuthRequest: "LINE Pay交易授權結果通知 Request JSON 物件",
      IpassAuthRequest: "一卡通交易授權 Request 物件",
      IpassAuthResponse: "一卡通交易授權 Response 物件",
      UpdateIpassAuthRequest: "一卡通交易授權結果通知 Request JSON 物件",
      CfcAuthRequest: "銀角零卡分期交易授權 Request 物件",
      CfcAuthResponse: "銀角零卡分期交易授權 Response 物件",
      UpdateCfcAuthRequest: "銀角零卡分期交易授權結果通知 Request JSON 物件",
      EzwAuthRequest: "悠遊付交易授權 Request 物件",
      EzwAuthResponse: "悠遊付交易授權 Response 物件",
      UpdateEzwAuthRequest: "悠遊付交易授權結果通知 Request JSON 物件",
      JkoAuthRequest: "街口交易授權 Request 物件",
      JkoAuthResponse: "街口交易授權 Response 物件",
      UpdateJkoAuthRequest: "街口交易授權結果通知 Request JSON 物件",
      PxPayAuthRequest: "全支付交易授權 Request 物件",
      PxPayAuthResponse: "全支付交易授權 Response 物件",
      UpdatePxPayAuthRequest: "全支付交易授權結果通知 Request JSON 物件",
      UpopAuthRequest: "銀聯卡交易授權 Request 物件",
      UpopAuthResponse: "銀聯卡交易授權 Response 物件",
      UpdateUpopAuthRequest: "銀聯卡交易授權結果通知 Request JSON 物件",
      AfteeQueryRequest: "AFTEE交易查詢 Request 物件",
      AfteeQueryResponse: "AFTEE交易查詢 Response 物件",
      LinepayQueryRequest: "LINE Pay交易查詢 Request 物件",
      LinepayQueryResponse: "LINE Pay交易查詢 Response 物件",
      JkoQueryRequest: "街口交易查詢 Request 物件",
      JkoQueryResponse: "街口交易查詢 Response 物件",
      PxPayQueryRequest: "全支付交易查詢 Request 物件",
      PxPayQueryResponse: "全支付交易查詢 Response 物件",
      UpopQueryRequest: "銀聯卡交易查詢 Request 物件",
      UpopQueryResponse: "銀聯卡交易查詢 Response 物件",
      IpassQueryRequest: "一卡通交易查詢 Request 物件",
      IpassQueryResponse: "一卡通交易查詢 Response 物件",
      EzwQueryRequest: "悠遊付交易查詢 Request 物件",
      EzwQueryResponse: "悠遊付交易查詢 Response 物件",
      CfcQueryRequest: "銀角零卡分期交易查詢 Request 物件",
      CfcQueryResponse: "銀角零卡分期交易查詢 Response 物件",
      QueryOrderRequest: "信用卡交易查詢 Request 物件",
      QueryOrderResponse: "信用卡交易查詢 Response 物件",
      QueryFunbizOrderRequest: "豐收款交易查詢 Request 物件",
      QueryFunbizOrderResponse: "豐收款交易查詢 Response 物件",
      AuthReverseRequest: "取消交易授權 Request 物件",
      AuthReverseResponse: "取消交易授權 Response 物件",
      CaptureRequest: "交易請款 Request 物件",
      CaptureResponse: "交易請款 Response 物件",
      CaptureReverseRequest: "取消交易請款 Request 物件",
      CaptureReverseResponse: "取消交易請款 Response 物件",
      RefundRequest: "交易退款 Request 物件",
      RefundResponse: "交易退款 Response 物件",
      RefundReverseRequest: "取消交易退款 Request 物件",
      RefundReverseResponse: "取消交易退款 Response 物件",
      UpopAuthReverseRequest: "取消銀聯交易授權 Request 物件",
      UpopAuthReverseResponse: "取消銀聯交易授權 Response 物件",
      UpopCaptureRequest: "銀聯交易請款 Request 物件",
      UpopCaptureResponse: "銀聯交易請款 Response 物件",
      UpopCaptureReverseRequest: "取消銀聯交易請款 Request 物件",
      UpopCaptureReverseResponse: "取消銀聯交易請款 Response 物件",
      UpopRefundRequest: "銀聯交易退款 Request 物件",
      UpopRefundResponse: "銀聯交易退款 Response 物件",
      UpopRefundReverseRequest: "取消銀聯交易退款 Request 物件",
      UpopRefundReverseResponse: "取消銀聯交易退款 Response 物件",
      CardholderVerifyRequest: "手機門號驗證 Request 物件",
      CardholderVerifyResponse: "手機門號驗證 Response 物件",
      VirtualAccountPaymentRequest: "虛擬帳號付款交易 Request 物件",
      VirtualAccountPaymentResponse: "虛擬帳號付款交易 Response 物件",
      UpdateVirtualAccountPaymentRequest:
        "虛擬帳號訂單成立通知 Request JSON 物件",
      VirtualAccountQueryRequest: "虛擬帳號訂單查詢 Request 物件",
      VirtualAccountQueryResponse: "虛擬帳號訂單查詢 Response 物件",
      SpbVirtualAccountRefundRequest: "永豐虛擬帳號退款 Request 物件",
      SpbVirtualAccountRefundResponse: "永豐虛擬帳號退款 Response 物件",
      UpdateVirtualAccountSettlementRequest:
        "虛擬帳號銷帳通知 Request JSON 物件",
      CvsPaymentRequest: "超商代收 Request 物件",
      CvsPaymentResponse: "超商代收 Response 物件",
      UpdateCvsPaymentRequest: "超商代收訂單成立通知 Request JSON 物件",
      CvsQueryRequest: "超商代收訂單查詢 Request 物件",
      CvsQueryResponse: "超商代收訂單查詢 Response 物件",
      UpdateCvsSettlementRequest: "超商代收銷帳通知 Request JSON 物件",
      EasypayCreateRequest: "方便付建立付款連結 Request 物件",
      EasypayCreateResponse: "方便付建立付款連結 Response 物件",
      EasypayQueryRequest: "方便付訂單查詢 Request 物件",
      EasypayQueryResponse: "方便付訂單查詢 Response 物件",
      EasypayUpdateRequest: "方便付訂單狀態變更 Request 物件",
      EasypayUpdateResponse: "方便付訂單狀態變更 Response 物件",
      CancelRecurringPaymentRequest: "取消定期定額訂單 Request 物件",
      CancelRecurringPaymentResponse: "取消定期定額訂單 Response 物件",
      ResendRecurringPaymentRequest: "重送交易失敗定期定額訂單 Request 物件",
      ResendRecurringPaymentResponse: "重送交易失敗定期定額訂單 Response 物件",
      QueryRecurringPaymentRequest: "定期定額訂單查詢 Request 物件",
      QueryRecurringPaymentResponse: "定期定額訂單查詢 Response 物件",
      VeriIdReviewOrderRequest: "Veri-id 審核風險交易 Request 物件",
      VeriIdReviewOrderResponse: "Veri-id 審核風險交易 Response 物件",
      VeriIdQueryRiskTransactionDataRequest:
        "查詢交易 Veri-id 風險偵測結果 Request 物件",
      VeriIdQueryRiskTransactionDataResponse:
        "查詢交易 Veri-id 風險偵測結果 Response 物件",
      JpayAuthRequest: "J-PAY交易授權 Request 物件",
      JpayAuthResponse: "J-PAY交易授權 Response 物件",
      UpdateJpayAuthRequest: "J-PAY交易授權結果通知 Request JSON 物件",
      JpayQueryOrderRequest: "J-PAY交易查詢 Request 物件",
      JpayQueryOrderResponse: "J-PAY交易查詢 Response 物件",
      AuthUpdateParamPs:
        '<ol class=\'bullet-list\'><li>商戶接收成功，請回應 JSON 格式資料 {\'{"code": "0000","message": "ok","success": true}\'}</li><li>接收失敗，請回應 JSON 格式資料 {\'{"code": "1111","message": "error","success": false}\'}</li></ol>',
    },
  },
  table: {
    Header: {
      level: "階層",
      JSONAttributeName: "Json attribute Name",
      type: "型態",
      required: "必要欄位",
      description: "說明",
    },
    Body: {
      data: "<b>回應資料</b>",
      code: "<b>回應碼</b><br>#回傳訊息對照表（retcode）",
      code_simple: "<b>回應碼</b>",
      message: "<b>回應訊息</b>",
      success: "<b>請求是否成功</b>",
      errorMessage: "<b>錯誤訊息</b>",
      resFalse: "<b>回傳false</b>",
      code_is0000: "<b>成功一律回0000</b>",
      errorCode: "<b>非0000 錯誤代碼</b>",
      api_jsonObj: "<b>API 規格 Response JSON 物件</b>",
      emptyString: "<b>值為空字串</b>",
      resTrue: "<b>回傳true</b>",
      merid: "<b>商家代碼</b>",
      orderNumber_19: "<b>訂單號碼</b><br>長度限制 19 碼，限制英數字",
      orderNumber_20: "<b>訂單號碼</b><br>長度限制 20 碼，限制英數字",
      orderNumber_19_recurring:
        "<b>首期訂單號碼</b><br>長度限制 19 碼，限制英數字",
      currency: "<b>幣別</b><br>商家申請時設定的幣別<br>(依 ISO 4217之規定)",
      amount: "<b>交易金額</b><br>須包含兩位小數 Ex.若輸入值為 100,則代表 1 元",
      orderDesc: "<b>訂單說明</b><br>長度限制中文 20 個字",
      easypayOrderDesc: "<b>訂單描述</b><br>長度限制中文 20 個字或英文 40 個字",
      depositFlag:
        "<b>自動請款標記</b><br>1: Sale 交易: 自動請款<br>0: 一般交易",
      queryFlag:
        "<b>查詢標記</b><br>1: HiTRUSTpay 會將本筆交易的詳細資料以 POST 的方式送至updateURL<br>0: 一般資料",
      transactionQueryFlag:
        "<b>查詢標記</b><br>1: 詳細資料:當您啟動本參數時，HiTRUSTpay將會回傳本筆交易的詳細資料<br>0: 一般資料",
      returnURL: "<b>指定接續網址</b><br>授權結束後商家指定轉倒網址",
      updateURL:
        "<b>回傳結果網址</b><br>HiTRUSTpay 主動通知商家交易結果網址，沒有設定連結，則不主動通知",
      apUpdateURL: "<b>通知回傳網址</b>",
      pan: "<b>信用卡卡號</b>",
      expiry: "<b>有效期限</b><br>格式 YYMM",
      cvv2: "<b>CVC2/CVV2</b><br>安全碼，若商家有向網威智慧申請開啟CVC2/CVV2檢核功能，此欄位必須帶末三碼驗證碼",
      creditCard: "<b>信用卡資訊</b>",
      installmentPeriod: "<b>分期期數</b>",
      redeemFlag:
        "<b>是否使用紅利點數功能</b><br>0:不使用<br>1:使用<br>*紅利點數功能與分期功能無法同時使用",
      idNumber: "<b>持卡人身分證字號</b><br>英文字母大寫開頭",
      cellPhoneNumber:
        "<b>持卡人行動電話號碼</b><br>長度限制 15 碼，非必要欄位，必須配合持卡人身分證字號共同進行驗證",
      birthYear:
        "<b>持卡人出生日西元年</b><br>yyyy，非必要欄位，必須配合持卡人身分證字號及持卡人出生日進行驗證",
      birthDate:
        "<b>持卡人出生日</b><br>MMdd，非必要欄位，必須配合持卡人身分證字號及持卡人出生年進行驗證",
      homePhoneNumber:
        "<b>持卡人居家電話</b><br>長度限制 15 碼，非必要欄位，必須配合持卡人身分證字號進行驗證(本參數僅限於台銀銀行收單自行卡交易使用)",
      officePhoneNumber:
        "<b>持卡人公司電話</b><br>長度限制 15 碼，非必要欄位，必須配合持卡人身分證字號進行驗證(本參數僅限於台銀銀行收單自行卡交易使用)",
      authenticateOnly:
        "<b>是否為純身分認證</b><br>Y：是 (只進行身分認證，金額必須為零)<br>N : 否",
      cardholderInfo:
        "<b>身分認證交易資訊</b><br>cardholderInfo不為空時，持卡人資訊至少一欄位必須有值",
      subMerchant: "<b>次特店資訊</b>",
      subMerid:
        "<b>次特店代號</b><br>次特店代號長度為 8 碼時,會驗證 次特店MCC、次特店名稱長度",
      subMcc:
        "<b>次特店MCC</b><br>次特店行業類別碼，次特店代號長度為8碼時,固定為 4 碼",
      subMerName:
        "<b>次特店名稱</b><br>次特店英文店名簡稱，次特店代號長度為8碼時,不可超過 10 碼",
      recurringPaymentSetting: "<b>定期定額資訊</b>",
      periods: "<b>扣款期數</b><br>數字(0-9)",
      cycle: "<b>扣款週期</b><br>數字(0-9)",
      cycleType: "<b>扣款週期種類</b><br>D：天 W：週 M：月 Y：年",
      recurringUpdateURL:
        "<b>定期定額結果回傳網址</b><br>若交易為定期定額，且設定定期定額結果回傳網址，排程執行後會明文送到該網址(POST)",
      subsequentSetting: "<b>定期定額 - 次期設定</b>",
      phoneNumber:
        "<b>消費者手機號（用於扣款失敗或末期通知）</b><br>如需使用本功能，須向 HiTRUSTpay 提出申請，並於完成相關設定後方可啟用；此外，啟用本功能將另行產生額外費用。",
      recurringStartDate: "<b>指定下次扣款日期</b><br>格式 yyyy-MM-dd",
      recurringTransAmount:
        "<b>指定下次扣款金額</b><br>須包含兩位小數 Ex.若輸入值為 100,則代表 1 元",
      recurringDepositFlag: "<b>次期扣款類型</b><br>0:一般交易<br>1:SALE交易",
      extensionField: "<b>延伸欄位</b>",
      threeDSExtraField: "<b>3DS 驗證額外資訊</b>",
      enName:
        "<b>持卡人英文姓名拼音</b><br>長度限制 2-45 碼，限制英文字、空白格 與 - ，持卡人手機號碼(含國碼)與電子信箱擇一必填<br>*若欄位值為空時，請填入空字串",
      mobileCC:
        "<b>持卡人手機國碼</b><br>長度限制 1-3 碼，限制數字，輸入持卡人手機號碼時必填<br>*若欄位值為空時，請填入空字串",
      mobilePhone:
        "<b>持卡人手機號碼</b><br>長度限制 15 碼，限制數字，輸入持卡人手機國碼時必填<br>*若欄位值為空時，請填入空字串",
      cardholderEmail:
        "<b>持卡人電子信箱</b><br>長度限制 254 碼<br>*若欄位值為空時，請填入空字串",
      cancelURL: "<b>取消連結</b>",
      eInvoice: "<b>電子發票資訊</b>",
      invoiceEmail: "<b>電子發票email</b><br>可預設為寄送方式為email",
      invoiceItem: "<b>電子發票商品資訊</b>",
      productionCode:
        "<b>電子發票商品品名代號</b><br>長度:20 英數字 / 10 中文字",
      description: "<b>電子發票商品品名</b><br>長度:256 英數字 / 128 中文字",
      quantity: "<b>電子發票商品數量</b><br>長度:17 數字",
      unit: "<b>電子發票商品單位</b><br>長度:6 英數字 / 3 中文字",
      unitPrice: "<b>電子發票商品單價</b><br>長度:17 數字",
      transType:
        "<b>交易類別</b><br>1:授權 3:請款 4:取消請款 5:退款 6:取消退款 7:查詢 8:取消授權",
      transType_simple: "<b>交易類別</b>",
      retCode: "<b>交易結果</b><br>#回傳訊息對照表（retcode）",
      authCode: "<b>銀行授權碼</b>",
      authRRN: "<b>銀行調單編號</b>",
      panMask:
        "<b>遮罩後卡號</b><br>遮罩卡號前六後四碼，需先向網際威信申請開啟回傳設定",
      merUpdateQueryDetail:
        "<b>授權結果明細</b><br>(queryFlag=1，欄位才會有值)",
      orderStatus: "<b>訂單狀態碼</b><br>#訂單狀態碼",
      eci: "<b>授權方式</b><br>SSL,VISA3D",
      orderDate: "<b>訂單日期</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      apOrderDate: "<b>訂單日期</b><br>YYYY-MM-DD",
      approveAmount: "<b>核准金額</b>",
      captureAmount: "<b>請款金額</b>",
      payBatchNum: "<b>請款批次號碼</b>",
      captureDate: "<b>請款日期</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      refundAmount: "<b>退款金額</b>",
      refundBatch: "<b>退款批次號碼</b>",
      refundRRN: "<b>退款調單編號</b>",
      refundCode: "<b>退款授權碼</b>",
      refundDate: "<b>退款日期</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      redemOrderNum: "<b>紅利點數銷帳編號</b>",
      redemDiscountPoint: "<b>本次折抵點數</b>",
      redemDiscountAmount: "<b>本次折抵金額</b>",
      redemPurchaseAmount: "<b>本次實付金額</b>",
      redemBalancePoint: "<b>剩餘點數</b>",
      firstPeriodAmount: "<b>首期金額</b>",
      periodicAmount: "<b>每期金額</b>",
      trxTokenInfo: "<b>交易序號資訊</b>",
      trxToken: "<b>交易序號</b>",
      ifShowTrxToken: "當showTrxToken=true有值",
      reqTrxToken: "速速付交易序號",
      cvv2_trx:
        "<b>CVC2/CVV2</b><br>安全碼，若商家有向網威智慧申請開啟CVC2/CVV2檢核功能，此欄位必須帶末三碼驗證碼",
      token:
        "<b>付款頁網址以及溝通標記</b><br>付款網頁之位置及溝通參數(將使用者導至付費網頁用)",
      riskDetectCode:
        "<b>風險偵測狀態</b><br>商家啟用風險偵測服務時有值<br>low (低),mid(中), high(高)",
      riskActionStatus:
        "<b>風險審核狀態</b><br>商家啟用風險偵測服務時有值<br>RMCA(人工審核通過)<br>RMCR(人工審核拒絕)<br>REAP(策略待審查)<br>REAA(風險策略通過)<br>REAR(風險策略拒絕)",
      bindingWithVerify: "<b>是否一併手機門號驗證</b><br>是:1<br>否:0",
      bindingCardCardholderInfo:
        "<b>手機門號驗證 持卡人資訊</b><br>BindingWithVerify =1時，手機門號驗證資訊至少一欄位不為空",
      idNumber_9: "<b>持卡人身分證字號</b><br>英文字母大寫開頭，接9位數字",
      birthday: "<b>持卡人生日</b><br>yyyyMMdd",
      cellPhoneNumber_10: "<b>持卡人手機門號</b><br>長度限制 10 碼",
      lastBindCardTime: "<b>交易序號產生時間</b><br>yyyy-MM-dd.HH.mm",
      paymentQueryResult:
        "<b>交易查詢明細結果</b><br>當 queryFlag =1，才會有值",
      QueryPaymentQueryResult: "<b>交易查詢明細結果</b>",
      creditCardTransactionResult:
        "<b>信用卡交易明細結果</b><br>當 queryFlag =1，才會有值",
      QueryCreditCardTransactionResult:
        "<b>信用卡交易明細結果</b><br>信用卡交易，才會有值",
      TransactionCreditCardTransactionResult:
        "<b>信用卡交易明細結果</b><br>當您啟動 queryFlag =1 且為信用卡交易，才會有值",
      walletType:
        "<b>啟用行動支付類型</b><br>1: 啟用 Applepay<br>2: 啟用 pay with google<br>3: 啟用 Samsung Pay",
      mobileWalletPaymentData: "<b>Apple/google 回傳的 data json 資料</b>",
      encryptedByGW:
        "<b>加密註記</b><br>Y: 店家使用HiTRUST憑證<br>N:店家不要使用HiTRUST憑證加密，預設 Y 使用HiTRUST憑證",
      tavv: "<b>TAVV</b><br>當 walletType為 1 時，請帶入解密後的 TAVV 值",
      eci_decrypted:
        "<b>ECI</b><br>當 walletType為 1 時，請帶入解密後的 ECI 值",
      afteeMerUserNo: "<b>AFTEE 商家會員 ID</b>",
      afteeCustomer: "<b>消費者資料</b>",
      customer_name: "<b>姓名</b><br>100 字以內文字",
      phone_number: "<b>手機號碼</b><br>09 開頭 10 位半形數字",
      address: "<b>地址</b><br>255字以内文字",
      email: "<b>電子郵件</b>",
      email225: "255字以内正確電子信箱格式",
      additional_info_code: "<b>額外資訊碼</b><br>請帶入空字串",
      user_registration_date: "<b>商家會員註冊日期</b><br>格式 YYYY-MM-DD",
      afteeDestCustomers: "<b>收件者資料</b>",
      dest_customer_name: "<b>姓名</b><br>100字以內文字",
      dest_address: "<b>地址</b><br>255 字以内文字 不含空白鍵",
      dest_tel: "<b>電話號碼</b><br>0 開頭 9～10 位數的半形數字,市話須包含區碼",
      afteeItems: "<b>消費商品資料</b>",
      jPayCustomer: "<b>消費者資料</b>",
      pay_firstname: "<b>帳單姓名</b>",
      pay_lastname: "<b>帳單姓氏</b>",
      pay_street_address1: "<b>帳單地址1</b>",
      pay_street_address2: "<b>帳單地址2</b>",
      pay_city: "<b>帳單城市</b>",
      pay_postcode: "<b>帳單郵遞區號</b>",
      pay_state: "<b>帳單州/省</b>",
      pay_country_iso_code_2: "<b>帳單國家</b>",
      pay_email_address: "<b>帳單信箱</b>",
      pay_telephone: "<b>帳單電話</b>",
      jPayDestCustomer: "<b>收件人資料</b>",
      shipping_firstname: "<b>收件人姓名</b>",
      shipping_lastname: "<b>收件人姓氏</b>",
      shipping_street_address1: "<b>收件人地址1</b>",
      shipping_street_address2: "<b>收件人地址2</b>",
      shipping_city: "<b>收件人城市</b>",
      shipping_postcode: "<b>收件人郵遞區號</b>",
      shipping_state: "<b>收件人州/省</b>",
      shipping_country_iso_code_2: "<b>收件人國家</b>",
      shipping_email_address: "<b>收件人信箱</b>",
      shipping_telephone: "<b>收件人電話</b>",
      jPayItems: "<b>商品資訊</b>",
      sku: "<b>商品編號(唯一)</b>",
      productName: "<b>商品名稱</b>",
      productImage: "<b>商品圖片</b>",
      attributes: "<b>商品屬性</b>",
      price: "<b>商品價格</b>",
      quantity: "<b>商品數量</b>",
      shop_item_id: "<b>店舖商品 ID</b><br>半形英文或數字 100 字以内 不含空白",
      item_name: "<b>商品名稱</b><br>100 字以內文字 不含空白鍵",
      item_category:
        "<b>商品 Category</b><br>100 字以內文字 不含空白，若無值請帶空字串",
      item_price:
        "<b>商品單價</b><br>0 或不超過 6 位數的整數 ,左側不須填入 0、包含負值",
      item_count: "<b>個數</b><br>1 以上不超過 5 位數的整数 ,左側不須填入 0",
      item_url: "<b>商品 URL</b><br>1000 字以内文字 ,若無值請帶空字串",
      discount: "<b>交易折扣</b>",
      interactionInfo: "<b>互動式附言欄位</b>",
      interactionType:
        "<b>屬性</b><br>M 表示 欄位值 必填，O 表示 欄位值 可選填",
      fieldName:
        "<b>欄位名稱</b><br>(長度 1…30 bytes)：不可包含分隔符號逗號 ,沒有值請留空白",
      fieldValue:
        "<b>欄位值</b><br>長度 1…30 bytes)：可有預設值或由付款人輸入，且不可包含分隔符號逗號 , 沒有值請留空白",
      editable: "<b>欄位值是否可編輯</b><br>Y 表示可編輯<br>N 表示不可編輯",
      cfcBuyerInfo:
        "<b>銀角零卡會員資料</b><br>兩種用途：<br>指定訂購人才能結帳(避免否認交易)加審核通過機率",
      specific_id: "<b>會員身份證字號</b>",
      shipping_address: "<b>收件地址</b>",
      account_age:
        "<b>帳號資歷</b><br>會員帳號註冊至今年資，false 未滿 30 天、true 為 30 天以上",
      last_order_date: "<b>上次消費日期</b><br>格式：yyyy-mm-dd",
      last_order_amount: "<b>上次消費金額</b>",
      cfcValidDays:
        "<b>銀角零卡預約有效天數</b><br>payment_url 有效日，最短 1 天(當天)，最長30 天預設 7 天",
      cfcInstallmentPeriod:
        "<b>可使用分期期數</b><br>ex 1:一次付清 , 3 : 為分三期",
      jkoRedeemAmount: "<b>總折抵金額</b><br>(queryFlag=1，欄位才會出現)",
      jkoRedeemJkoCoinamount:
        "<b>街口幣折抵</b><br>(queryFlag=1，欄位才會出現)",
      jkoRedeemOfficialCouponAmount:
        "<b>官方街口券折抵</b><br>(queryFlag=1，欄位才會出現)",
      jkoRedeemStoreCouponAmount:
        "<b>店家街口券折抵</b><br>(queryFlag=1，欄位才會出現)",
      jkoDebitAmount: "<b>折抵後金額</b><br>(queryFlag=1，欄位才會出現)",
      jkoChannelType:
        "<b>支付工具</b><br>account: 儲值帳戶<br>bank: 銀行帳戶<br>creditcard: 信用卡<br>(queryFlag=1，欄位才會出現)",
      showTrxToken: "<b>是否回傳交易序號</b>",
      trxStatusCode: "<b>交易狀態</b><br>當showTrxToken=true有值",
      payWay:
        "<b>支付類型</b><br>1 : Apple Pay<br>2 : Google Pay(Wallet Mode)<br>3 : Samsung Pay<br>4 : Google Pay(Account Mode)<br>5 : LINE Pay<br>6 : 速速付<br>other : 一般",
      linePayRtnCode: "<b>LINEPAY 交易回覆碼</b><br>LINEPAY 交易專用",
      linePayTransId: "<b>LINEPAY 交易序號</b><br>LINEPAY 交易專用",
      virtualAccountInfo: "<b>虛擬帳號資訊</b>",
      bankCode: "<b>銀行代碼</b>",
      virtualAccount: "<b>虛擬帳號</b>",
      expireDate: "<b>繳費期限</b>",
      cvsInfo: "<b>超商代收資訊</b>",
      paymentNo: "<b>繳費代碼</b>",
      apName: "<b>消費者名稱</b><br>長度限制 50 字",
      apEmail: "<b>消費者EMAIL</b><br>長度限制 50 字",
      cvsName: "<b>姓名</b><br>長度限制 50 字",
      cvsEmail: "<b>EMAIL</b><br>長度限制 50 字",
      payDueDate: "<b>繳費期限</b><br>yyyyMMdd",
      transDate: "<b>繳費日期</b><br>YYYYMMDD",
      csvPayDate: "<b>繳費日期</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      csvChargeOffDate: "<b>銷帳日期</b><br>YYYY-MM-DD-HH.MM.SS.XXXXXX",
      apDate: "<b>銷帳日期</b><br>YYYY-MM-DD",
      orderStatus_va_settlement:
        "<b>訂單狀態碼</b><br>10 : 未銷帳(非永豐收單)<br>11 : 已銷帳<br>12 : 未繳清<br>14 : 溢繳<br>16 : 未銷帳(永豐收單)",
      orderStatus_spb_va_settlement:
        "<b>訂單狀態碼</b><br>10 : 未銷帳(非永豐收單)<br>11 : 已銷帳<br>12 : 未繳清<br>14 : 溢繳<br>16 : 未銷帳(永豐收單)<br>20 : 退款中(永豐收單)<br>21 : 退款失敗(永豐收單)<br>22 : 已退款(永豐收單)<br>23 : 已失效(永豐收單)",
      orderStatus_cvs_settlement:
        "<b>訂單狀態碼</b><br>20 : 未銷帳<br>21 : 已銷帳",
      barcode1: "<b>Barcode1</b>",
      barcode2: "<b>Barcode2</b>",
      barcode3: "<b>Barcode3</b>",
      orderAmount: "<b>訂單金額</b><br>需除以 100 方為實際金額",
      transAmount: "<b>當次銷帳金額</b><br>需除以 100 方為實際金額",
      emailAddress: "<b>付款人 Email</b><br>多組Email帳號請用「,」分開",
      orderName: "<b>收款名稱</b>",
      orderNameLimit: "長度限制中文 10 個字或英文 20 個字",
      availableStartDate: "<b>有效日期起日</b><br>yyyy/MM/dd",
      availableEndDate: "<b>有效日期迄日</b><br>yyyy/MM/dd",
      installmentPlans:
        "<b>可分期期數</b><br>請用「,」分開 EX:可使用 3期及 6 及，則為 0,3,6",
      noticeMail: "<b>付款完成通知Email</b>",
      easyPayLink:
        "<b>付款連結</b><br>付款連結須加上方便付明細的token 值，才會是正確的付款連結網址",
      easyPayOrderDetails: "<b>方便付明細結果</b>",
      easyPayUpdateURL: "<b>付款完成通知updateURL</b>",
      mail: "<b>付款人 Email</b>",
      orderId: "<b>訂單序號</b>",
      easypayQueryEmail:
        "<b>付款人Email</b><br>只能查詢一組 Email<br>(查詢條件至少一個不為空)",
      availableStartDateQuery:
        "<b>有效日期起日</b><br>格式yyyy/MM/dd<br>(查詢條件至少一個不為空)",
      availableEndDateQuery:
        "<b>有效日期迄日</b><br>格式yyyy/MM/dd<br>(查詢條件至少一個不為空)",
      createStartDate:
        "<b>建立日期起日</b><br>格式yyyy/MM/dd<br>(查詢條件至少一個不為空)",
      createEndDate:
        "<b>建立日期迄日</b><br>格式yyyy/MM/dd<br>(查詢條件至少一個不為空)",
      easyPayOrderId: "<b>方便付訂單 ID</b><br>(查詢條件至少一個不為空)",
      queryMaskPan: "<b>是否回傳遮罩卡號</b><br>0:不回傳<br>1:回傳",
      startDate: "<b>付款起始日</b><br>yyyyMMddHHmmss",
      endDate: "<b>付款截止日</b><br>yyyyMMddHHmmss",
      createDate: "<b>付款建立日期</b><br>yyyyMMddHHmmss",
      easypayStatus: "<b>付款狀態</b><br>0:未付款 1:付款中 2:已付款 5:暫停付款",
      payDate: "<b>付款日期</b>",
      installmPlan: "<b>可分期期數</b>",
      paytype: "<b>付款類型</b><br>1: Sale 交易<br>0: 一般交易",
      maskPan: "<b>遮罩卡號</b>",
      maskPanDesc:
        "僅在 queryMaskPan= 1 以及付款狀態為已付款的訂單才會有資料，其餘皆為 maskpan",
      easypayUpdateToken: "<b>Token</b>",
      easypayUpdateEmail: "<b>付款人 Email</b>",
      changeStatusTo:
        "<b>修正的狀態值(只能0 or 5)</b><br>0:未付款<br>5:暫停付款",
      periodOrderNumber: "<b>失敗的當期訂單編號</b>",
      recurringPaymentData: "<b>定期定額訂單</b>",
      recurringPaymentInfo: "<b>定期定額交易資訊</b>",
      createTime: "<b>訂單建立日期</b><br>YYYY-MM-DD-HH.MM.SS",
      periodType: "<b>週期種類</b><br>Y-年 , M-月 , D-日",
      deductFreq: "<b>扣款頻率</b>",
      deductTotalNum: "<b>扣款總期數</b>",
      deductChargedNum: "<b>已扣款期數</b>",
      recurringPaymentDetails: "<b>定期定額扣款交易明細</b>",
      periodNumber: "<b>期數</b>",
      recurringStatus:
        "<b>扣款狀態碼</b><br>00 已扣款<br>01 待扣款<br>02 扣款失敗<br>03 已終止定期定額",
      estimatedDeductDate: "<b>預計扣款日期</b>",
      trxStatus:
        "<b>失敗回傳代碼</b><br>僅有失敗交易才有值 , 詳細說明見回傳訊息對照表",
      approvable: "<b>是否可以通過審核</b><br>true: 通過<br>false:不通過",
      riskDetectCode_request: "<b>風險代碼</b><br>從待審核訂單查詢取得",
      operatorId: "<b>operatorId</b>",
      connectorId: "<b>連線ID</b>",
      instituteId: "<b>機構ID</b>",
      mac: "<b>商戶金鑰簽章值</b>",
      timestamp: "<b>時間戳記</b>",
      veriIdTransID: "<b>VeriId交易序號</b>",
      merTransID: "<b>商戶交易序號</b>",
      version: "<b>API版本號</b>",
      orderNumber_simple: "<b>訂單號碼</b>",
      html: "<b>與付費網頁溝通標記</b><br>付費網頁之位置及溝通參數(將使用者導至付費網頁用)",
    },
  },
};
